import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { User } from 'app/core/user';
import { ReportingFirebaseService } from '../admin/reporting/general.firebase.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable()
export class ExcelService {
    constructor(
        public reportService: ReportingFirebaseService,
    ) {

    }
    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public exportDoctorsAsExcelFile(json: User[], excelFileName: string): void {
        const doctors = json.filter(x => x.userType === 'doctor');
        const sheets: any = {};
        const sheetNames: any = [];

        doctors.forEach(doctor => {
            const docPatients: User[] = json.filter(x => x.doctorId === doctor.uid)
            const worksheeta: XLSX.WorkSheet = XLSX.utils.json_to_sheet(docPatients);
            sheets[doctor.firstName + ' ' + doctor.lastName] = worksheeta;
            sheetNames.push((doctor.firstName + ' ' + doctor.lastName).substring(0, 30))
        });

        const workbook: XLSX.WorkBook = { Sheets: sheets, SheetNames: sheetNames };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public exportEducatorAsExcelFile(json: User[], excelFileName: string): void {
        const educators = json.filter(x => x.userType === 'educator');
        const sheets: any = {};
        const sheetNames: any = [];

        educators.forEach(educator => {
            const educatorPatients: User[] = json.filter(x => x.educatorUid === educator.uid)
            const worksheeta: XLSX.WorkSheet = XLSX.utils.json_to_sheet(educatorPatients);

            sheets[educator.firstName + ' ' + educator.lastName] = worksheeta;
            sheetNames.push((educator.firstName + ' ' + educator.lastName).substring(0, 30))
        });

        const workbook: XLSX.WorkBook = { Sheets: sheets, SheetNames: sheetNames };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });


        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public exportAdvisorAsExcelFile(json: User[], excelFileName: string): void {
        const advisors = json.filter(x => x.userType === 'advisor');
        const sheets: any = {};
        const sheetNames: any = [];

        advisors.forEach(advisor => {

            const educatorPatients: User[] = json.filter(x => x.advisorUid === advisor.uid)
            const worksheeta: XLSX.WorkSheet = XLSX.utils.json_to_sheet(educatorPatients);

            sheets[advisor.firstName + ' ' + advisor.lastName] = worksheeta;
            sheetNames.push((advisor.firstName + ' ' + advisor.lastName).substring(0, 30))
        });

        const workbook: XLSX.WorkBook = { Sheets: sheets, SheetNames: sheetNames };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public exportPatientsAsExcelFile(json: User[], excelFileName: string): void {
        const patients = json.filter(x => x.userType === 'member');
        console.log(patients)

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(patients);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public async exportCollectionsAsExcelFile(collectionName: string, excelFileName: string): Promise<void> {
        const dataSnapshot = await this.reportService.getUserColl(collectionName)
        const sheets: any = {};
        const sheetNames: any = [];

        let data: any[] = []
        let worksheet: XLSX.WorkSheet;
        if (dataSnapshot) {
            dataSnapshot.forEach(doc => {
                data.push([
                    doc.data().uid,
                    JSON.stringify(doc.data()),
                ]);
                // completeSnapshot = completeSnapshot.concat(doc.data())
            });
            worksheet = XLSX.utils.json_to_sheet(data);
        } else {
            data = []
            worksheet = {}
        }
        sheets[collectionName] = worksheet;
        sheetNames.push(collectionName)

        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    public async exportPatientDataAsExcelFile(patientList: User[], excelFileName: string): Promise<void> {
        console.log('STARTING')
        const sheets: any = {};
        const sheetNames: any = [];
        let userDataTypes: string[] = [
            'Bloodpressure',
            'Cholesterol',
            'HDL',
            'HbA1c',
            'LDL',
            'MAUARC',
            'Triglycerides',
            'WaistCircumference',
            'WeightBmi',
            'calendar',
            'chat',
            'diabetesComplications',
            'events',
            'glucoseReadings',
            'images',
            'manage',
            'medication',
            'morbidities',
            'moveHistory',
            'notes',
            'notifications',
            'rewardsHistory',
            'targets'
        ]

        const patients = patientList.filter(x => x.userType === 'member');
        // let patients: any[] = []
        // patients.push(aaa[0])
        // patients.push(aaa[1])
        // patients.push(aaa[2])

        let worksheet: XLSX.WorkSheet;
        for (let index = 0; index < userDataTypes.length; index++) {
            const element = userDataTypes[index];
            const finalContent = []

            for (let i = 0; i < patients.length; i++) {
                const patient = patients[i];

                const dataSnapshot = await this.reportService.getUserCollDoc('users', patient.uid, element)

                dataSnapshot.forEach(doc => {
                    if (doc.data()) {
                        finalContent.push(doc.data())
                        console.log(finalContent);
                    }
                });
            }

            worksheet = XLSX.utils.json_to_sheet(finalContent);
            sheets[element] = worksheet;
            sheetNames.push(element)
        }

        userDataTypes = [
            'activity',
            'carePlan',
            'clinicalTargets',
            'learn',
            'plasmaGlucose'
        ];


        for (let index = 0; index < userDataTypes.length; index++) {
            const element = userDataTypes[index];

            const finalContent2 = []

            // let completeSnapshot: firebase.firestore.DocumentData[] = []

            for (let i = 0; i < patients.length; i++) {
                const patient = patients[i];

                const doc = await this.reportService.getUserCollDocCol('users', patient.uid, 'achieve', element)

                if (doc.data()) {
                    finalContent2.push(doc.data())
                }


                // data.push([
                //     patient.uid,
                //     JSON.stringify(dataSnapshot.data()),
                // ]);

                // completeSnapshot = completeSnapshot.concat(dataSnapshot.data())
                i = patients.length
            }

            // if (dataSnapshot) {
            //     data[0] = [
            //         'Data Object',
            //         JSON.stringify(dataSnapshot.data()),
            //     ]

            //     console.log(data)
            //     console.log('111111111111111')
            //     worksheet = XLSX.utils.json_to_sheet(data);
            //     console.log('22222222222222222')
            // } else {
            //     data = []
            //     worksheet = {}
            // }

            worksheet = XLSX.utils.json_to_sheet(finalContent2);
            sheets['achieve - ' + element] = worksheet;
            sheetNames.push('achieve - ' + element)
        }

        const workbook: XLSX.WorkBook = { Sheets: sheets, SheetNames: sheetNames };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
}
